import React from 'react';
import { Button } from '@mui/material';

const DSSecondaryButton = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof Button>
>((props, ref) => {
  const { variant = 'text', ...rest } = props;

  return (
    <Button
      ref={ref}
      color="secondary"
      variant={variant}
      {...rest}
      sx={{
        ...rest.sx,
      }}
    />
  );
});

DSSecondaryButton.displayName = 'DSSecondaryButton';

export default DSSecondaryButton;
